import { StyleSheet, View } from 'react-native'

import { Card } from '../../Card'

interface CardGroupsInterface {
  left?: boolean
  right?: boolean
}

const CardGroups = ({ left, right }: CardGroupsInterface) => {
  return (
    <View style={[styles.groupOfCards, left ? styles.leftGroupOfCards : styles.rightGroupOfCards]}>
      {right ? (
        <View style={{ bottom: 15 }}>
          <Card fontSize={40} shadow rotateDegrees="10deg" />
        </View>
      ) : null}
      <View style={right ? { marginLeft: 15 } : { marginRight: 10 }}>
        <View style={{ marginBottom: 5 }}>
          <Card fontSize={40} shadow rotateDegrees={left ? '-5deg' : '5deg'} />
        </View>
        <View style={right ? { right: 10 } : { left: 10 }}>
          <Card fontSize={40} shadow rotateDegrees={left ? '-10deg' : '5deg'} />
        </View>
      </View>
      {left ? (
        <View style={{ bottom: 10 }}>
          <Card fontSize={40} shadow rotateDegrees="-5deg" />
        </View>
      ) : null}
    </View>
  )
}

export default CardGroups

const styles = StyleSheet.create({
  groupOfCards: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  leftGroupOfCards: {
    left: -35,
    top: 40
  },
  rightGroupOfCards: {
    right: -35
  }
})
